import { baseCRUDAPI } from './base';

export default class Login extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'Login');
  }

  async loginUrl() {
    const resp = await this.axiosObject.get(`${this.apiBaseName}/LoginURL`);
    return resp.data;
  }

  async token(authObject) {
    const resp = await this.axiosObject.post(`${this.apiBaseName}/token`, authObject);

    return resp.data;
  }

  async exchange(exchangeToken) {
    const token = { authToken: exchangeToken };
    const resp = await this.axiosObject.post(`${this.apiBaseName}/exchange`, token);

    return resp.data;
  }
}
